import React from 'react';
import {
  People,
  Restaurant,
  EmojiEvents,
  Groups,
  Quiz,
  Celebration
} from '@mui/icons-material';
import EventLayout from '../../components/events/EventLayout';
import BackButton from '../../components/events/BackButton';
import EventHero from '../../components/events/EventHero';
import ImageCarousel from '../../components/events/ImageCarousel';
import EventMeta from '../../components/events/EventMeta';
import KeyTakeaways from '../../components/events/KeyTakeaways';
import styled from 'styled-components';

const ClosingMessage = styled.div`
  background: white;
  border-radius: 12px;
  padding: 40px;
  text-align: center;
  margin-top: 48px;
  margin-bottom: 60px;
  border: 1px solid rgba(0,0,0,0.1);

  h3 {
    font-family: var(--font-serif);
    font-size: 1.5rem;
    color: var(--color-text);
    margin-bottom: 16px;
  }

  p {
    font-size: 1rem;
    color: var(--color-text-light);
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
  }
`;

const SemaineDesAssos = () => {
  const eventData = {
    title: "EPFL Associations Week 2024",
    date: "February 19-23, 2024",
    location: "EPFL Campus",
    category: "Community Event",
    description: `SHALOM participated in the EPFL Associations Week 2024, showcasing our vibrant community and mission to connect Israeli students and promote cultural exchange. Visitors to our stand experienced Israeli hospitality with traditional refreshments, engaged in cultural activities, and learned about our various initiatives and upcoming events.`,
    media: [
      { src: '/events/semDesAss24/sda1.jpg', objectFit: 'cover', objectPosition: '50% 44%' },
    ],
    keyTakeaways: [
      {
        icon: <People style={{ fontSize: '24px' }} />,
        title: 'Impressive Turnout',
        description: "Over 300 visitors stopped by our stand, showing great interest in Israeli culture and our association's activities.",
        color: '#4F8EF7'
      },
      {
        icon: <Restaurant style={{ fontSize: '24px' }} />,
        title: 'Cultural Tastings',
        description: 'Visitors enjoyed traditional Israeli bread and dips, getting a literal taste of Israeli culture.',
        color: '#9C88FF'
      },
      {
        icon: <Quiz style={{ fontSize: '24px' }} />,
        title: 'Interactive Learning',
        description: 'Engaging quizzes about Israeli culture, history, traditions, and tech industry created interactive discussions.',
        color: '#50E3C2'
      },
      {
        icon: <Groups style={{ fontSize: '24px' }} />,
        title: 'Community Growth',
        description: 'Successfully recruited numerous new members who showed enthusiasm for our future events and activities.',
        color: '#FF6B9D'
      },
      {
        icon: <Celebration style={{ fontSize: '24px' }} />,
        title: 'Cultural Exchange',
        description: 'Created meaningful connections and fostered understanding of Israeli culture within the EPFL community.',
        color: '#FFB74D'
      }
    ]
  };

  const metaItems = [
    {
      icon: <EmojiEvents style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #4F8EF7, #9C88FF)',
      title: 'Major Campus Event',
      subtitle: 'EPFL Associations Week'
    },
    {
      icon: <People style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #50E3C2, #4DD0E1)',
      title: '300+ Visitors',
      subtitle: 'Stand Attendance'
    },
    {
      icon: <Restaurant style={{ fontSize: '24px' }} />,
      gradient: 'linear-gradient(135deg, #FF6B9D, #FF8A65)',
      title: 'Cultural Experience',
      subtitle: 'Traditional Food & Activities'
    }
  ];

  return (
    <EventLayout>
      <BackButton />
      <EventHero
        category={eventData.category}
        title={eventData.title}
        description={eventData.description}
      >
        <EventMeta items={metaItems} />
      </EventHero>

      <ImageCarousel
        media={eventData.media}
        interval={4000}
      />

      <KeyTakeaways items={eventData.keyTakeaways} />

      <ClosingMessage>
        <h3>Event Impact & Success</h3>
        <p>
          The EPFL Associations Week 2024 proved to be a tremendous success for SHALOM. Through engaging activities, cultural exchanges, and meaningful conversations, we were able to share the richness of Israeli culture with the EPFL community. The enthusiastic response and new member registrations demonstrate the growing interest in cultural diversity on campus. We're grateful to everyone who visited our stand and look forward to welcoming our new members at future events.
        </p>
      </ClosingMessage>
    </EventLayout>
  );
};

export default SemaineDesAssos;